import React, { useEffect, useState } from 'react';
import { formatDistanceToNow } from 'date-fns';
import CircleChart from '../../CircleChart';
import { getAgeInMilliseconds } from '../../../../utils/date';
import { getGrowth } from '../../../../utils/values';

const LastActivity = ({
  activityData,
  previousHighlight,
  isLoading,
  className = '',
}) => {
  const [data, setData] = useState([]);
  const [isSettingData, setIsSettingData] = useState(true);
  const [avgShare, setAvgShare] = useState('');

  useEffect(() => {
    if (activityData && !isLoading) {
      setIsSettingData(true);
      const total = activityData.buckets.reduce(
        (sum, { value }) => sum + value,
        0
      );
      if (total === 0) {
        setData([]);
        setTimeout(() => setIsSettingData(false), 100);
        setAvgShare('');
        return;
      }
      const newData = activityData.buckets.map((bucket) => {
        const percent = total ? ((bucket.value * 100) / total).toFixed(2) : 0;
        return {
          label: bucket.label,
          count: bucket.value,
          percent: +percent,
        };
      });

      const median = formatDistanceToNow(new Date(activityData.median), {
        addSuffix: true,
      });
      setAvgShare(`${median}`);
      setData(newData);
      setTimeout(() => setIsSettingData(false), 100);
    }
  }, [activityData, isLoading]);

  return (
    <div className={className || ''}>
      <CircleChart
        title="Last Activity"
        highlightText="Median time since Last Activity"
        highlightValue={avgShare}
        data={data}
        isLoading={isLoading || isSettingData}
        landscape
        growth={
          previousHighlight
            ? getGrowth(
                getAgeInMilliseconds(activityData?.median),
                getAgeInMilliseconds(previousHighlight?.median),
                formatDistanceToNow(new Date(previousHighlight.median), {
                  addSuffix: true,
                })
              )
            : null
        }
      />
    </div>
  );
};

export default LastActivity;
